import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CpdDropdown from '@/components/ui/CpdDropdown';
import { FacilitiesApi } from '@/api/clients/facilities';
import isAllowedForFacility from '@/utility';

const FacilityDropdown = ({
  value = '',
  onChange,
  label,
  required = false,
  error = false,
  helperText = '',
  placeholderKey = 'payments.filters.facilitiesPlaceholder',
  useFormsApi = true,
  apiParams = null,
  organizationId = null,
  parentKey,
  childKey,
  permission,
  ...props
}) => {
  const { t } = useTranslation();
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    const fetchFacilities = async () => {
      setLoading(true);
      setApiError(null);
      try {
        let facilitiesData;
        if (useFormsApi) {
          const params = organizationId ? { organizationId } : {};
          facilitiesData = await FacilitiesApi.getFacilitiesForForms(params);
        } else {
          const result = await FacilitiesApi.getFacilities(apiParams);
          facilitiesData = result.data;
        }
        setFacilities(facilitiesData);
      } catch (error) {
        console.error('Error fetching facilities:', error);
        setApiError(error);
        setFacilities([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFacilities();
  }, [useFormsApi, apiParams, organizationId]);

  const filteredFacilities = facilities.filter((facility) => {
    const isAllowed = isAllowedForFacility({
      parentKey,
      childKey,
      permission,
      facilityId: facility.id,
    });
    return isAllowed;
  });

  return (
    <CpdDropdown
      label={label}
      value={value}
      onChange={onChange}
      options={filteredFacilities}
      required={required}
      error={error}
      helperText={helperText}
      placeholder={t(placeholderKey)}
      loading={loading}
      apiError={apiError}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      sx={{ mb: 2, ...props.sx }}
      {...props}
    />
  );
};

export default FacilityDropdown;
